import { Pipe, PipeTransform } from '@angular/core';

import { NO_VALUE } from '@pipes';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateDhwScheduleMode',
})
export class TranslateDhwScheduleModePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string | undefined): string {
    if (!value) {
      return NO_VALUE;
    }

    if (this.customTranslationsService.DHW_SCHEDULE_MODES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.DHW_SCHEDULE_MODES[value] ?? value
      );
    }

    return value;
  }
}
